import axios from "axios";
// useEffect , injectIntl
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Redirect } from "react-router-dom";
import AppConfig from "../../../config/AppConfig";
import { myJsonEncrypt, myJsonDecrypt } from "../../../config/SecurityConfig";
import DialogSso from "./SSO/DialogSso";
import { Form, Button, Modal } from "react-bootstrap";

import {
  MenuList,
  MenuItem,
  ListItemIcon,
  Typography,
} from "@material-ui/core";
import UserIcon from "@material-ui/icons/Person";
class Login extends Component {

  state = {
    loading: false,
    status: "",
    login: false,
    dialogLoginSSO: true,
    showSetRole: false,
    username: "",
    password: "",
    roles: [],
    datauser: {},
    loadingAuth: false,
  }

  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search);
    let code = urlParams.get('code');
    if (code) {
      //fetch("http://103.56.190.112:8082/oauth2?code="+code+"&state=xyz")  
      // fetch("https://api-spmi.kemdikbud.go.id/oauth2?code="+code+"&state=xyz")  
      fetch("http://localhost:443/oauth2?code=" + code + "&state=xyz")
        .then(response => response.json())
        .then(jsondata => {
          this.setState(
            {
              username: jsondata.result.username,
              sso_token: jsondata.result.token,
              refresh_token: jsondata.result.refresh_token,
              expiry: jsondata.result.expiry,
              password: jsondata.result.id_pengguna,
              issso: true,
              dialogLoginSSO: false,
            }
          );
          this.handlesubmit();
        })
        .catch(function () {
          window.location.href = "https://api-spmi.kemdikbud.go.id";
        });
    } else {
      this.setState(
        {
          issso: false,
        });
    }
  }

  handlesubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({
      loading: true,
    })
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    // let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      //   session = 
      //   // "?token="+userdata.token+
      //   "?id_pengguna="+userdata.id_pengguna+
      //   "&id_unit="+sessiondata.i_idunit +
      //   "&id_role="+sessiondata.i_idrole;
    }

    const payload = {
      username: this.state.username,
      password: this.state.password,
      issso: this.state.issso ? "true" : "false"
    };

    const formData = new FormData()
    formData.append("data", myJsonEncrypt(JSON.stringify(payload)))

    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    axios.post(
      AppConfig.Authentication + session
      , formData)
      .then((res) => {
        let dec = myJsonDecrypt(res.data.result);
        let jresult = JSON.parse(dec);
        if (jresult.status === "error") {
          this.setState({
            loading: false,
            dialogLoginSSO: false,
          });
          this.setState({
            status: "Username atau password tidak ditemukan",
          });
        } else if (jresult.status === "noaccess") {
          this.setState({
            loading: false,
            dialogLoginSSO: false,
          });
          this.setState({
            status: "User belum memiliki role SPMI.",
          });
        } else {
          this.setState({
            loading: false,
            dialogLoginSSO: false,
            showSetRole: true,
            roles: jresult.user_data.roles,
            datauser: jresult.user_data,
          });
        }
      })
      .catch((err) => {
        this.setState({
          status: "Server error.",
          loading: false,
          dialogLoginSSO: false,
        });
      });
  }

  setWithExpiry = (key, value, ttl) => {
    let now = new Date();
    let item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  // kalo mati aja
  // const handlesubmit = (event) => {
  //     setLoading(true)
  //     if(user.username === 'daniel' && user.password === 'daniel'){
  //         setLoading(false)
  //         localStorage.setItem("nama","daniel")
  //         localStorage.setItem("login","true")
  //         setLogin(true)

  //     }else{
  //         setLoading(false)
  //         setStatus("Username atau password tidak ditemukan")  
  //     }
  // };


  handleClose() {
    this.setState({
      showSetRole: false,
      datauser: {},
      roles: [],
    });
  }

  setRole(e, i) {
    this.setState({
      loadingAuth: true,
      showSetRole: false,
    });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      //   session =
      //   // "?token="+userdata.token+
      //   "?id_pengguna="+userdata.id_pengguna+
      //   "&id_unit="+sessiondata.i_idunit +
      //   "&id_role="+sessiondata.i_idrole;
    }

    const payload = {
      id_role_pengguna: this.state.roles[i].id_role_pengguna,
      id_pengguna: this.state.datauser.id_pengguna,
      username: this.state.datauser.username,
      token: this.state.datauser.token,
      is_edit: this.state.datauser.is_edit,
    };
    const formData = new FormData()
    formData.append("data", myJsonEncrypt(JSON.stringify(payload)))


    axios.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    axios
      .post(AppConfig.SetRole + session, formData)
      .then((res) => {
        let dec = myJsonDecrypt(res.data.result);
        let jresult = JSON.parse(dec);
        if (jresult.status === "success") {
          localStorage.setItem("userdata", JSON.stringify(this.state.datauser));
          localStorage.setItem(
            "sessiondata",
            JSON.stringify(jresult.session_data)
          );
          localStorage.setItem("tahun_siklus", "2026");
          this.setWithExpiry("statlogin", "true", 7200 * 1000);
          this.setState({
            loadingAuth: false,
            login: true,
            showSetRole: false,
          });
        } else {
          this.setState({
            loadingAuth: false,
            status: "Login gagal.",
            showSetRole: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          loadingAuth: false,
          status: "Server error.",
          showSetRole: false,
        });
      });
  }

  render() {
    if (this.state.login) {
      window.location.reload(false)
      return <Redirect to="/dashboard" />
    }
    let diaglogSSO = <></>;
    if (this.state.dialogLoginSSO) {
      diaglogSSO = <DialogSso />;
    }

    let data_role = [];
    if (this.state.roles.length > 0) {
      this.state.roles.map((list, i) => {
        data_role.push(
          <MenuItem className="p-5" onClick={(event) => this.setRole(event, i)}>
            <ListItemIcon>
              <UserIcon />
            </ListItemIcon>
            <Typography variant="inherit">
              {list.nm_peran} ({list.nm_lemb}) - {(list.id_bp === 1) ? "Akademik" : (list.id_bp === 2) ? "Vokasi" : "Semua"}
            </Typography>
          </MenuItem>
        );
      });
    }
    return (

      <div className="login-form login-signin" id="kt_login_signin_form">

        <div className="text-center mb-10 mb-lg-20">
          <h3 className="font-size-h1">
            <FormattedMessage id="AUTH.LOGIN.TITLE" />
          </h3>
          <p className="font-size-h4 font-weight-bold">
            Enter your username and password
          </p>
        </div>

        {this.state.status ? (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{this.state.status}</div>
          </div>
        ) : (
          ''
        )}

        <Form onSubmit={this.handlesubmit}>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="Username"
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="username"
              value={this.state.username}
              onChange={this.onChange}
              required
            />
          </div>

          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="Password"
              type="password"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="password"
              value={this.state.password}
              onChange={this.onChange}
              required
            />
          </div>

          <button
            id="kt_login_signin_submit"
            type="submit"
            className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
          >
            <span>Sign In</span>
            {this.state.loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </Form>
        <Modal size="lg" show={this.state.showSetRole}>
          <Modal.Header closeButton>
            <Modal.Title>Login As</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MenuList className="m-0 p-0">{data_role}</MenuList>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.handleClose()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* {diaglogSSO} */}
        <Modal
          size="sm"
          show={this.state.loadingAuth}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <div className="text-center">
              <span className="spinner spinner-black"></span> <span className="ml-8"> Silahkan ditunggu ... </span>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}
export default Login;